import React, {useEffect} from 'react'
import { Nav, Box, Heading, Button,Spinner } from 'grommet'
import {Menu as MenuIcon} from "grommet-icons";
import {withRouter} from 'react-router-dom'
import { Storage } from 'aws-amplify';


function NavigationBar(props) {
  const [logoUrl, setLogoUrl] = React.useState("")
  const [logoLoad, setLogoLoad] = React.useState(true)
  useEffect(() => {     
    setTimeout(() => {
      if (props.org === undefined || props.org === ""){
        setLogoUrl("https://images.squarespace-cdn.com/content/v1/61d5a187b2ab1944309a1189/a4f11595-f467-41b3-b263-c1ec02bf46f7/sl-white.png?format=1500w")
      } else if (props.org.logo_key === undefined || props.org.logo_key === "") {
        setLogoUrl("https://images.squarespace-cdn.com/content/v1/61d5a187b2ab1944309a1189/a4f11595-f467-41b3-b263-c1ec02bf46f7/sl-white.png?format=1500w")
      } else {
        Storage.list(props.org.logo_key) 
        .then(result => {
            Storage.get(result[0].key).then(res => {
              setLogoUrl(res)
              setLogoLoad(false)
            }).catch(err => console.log(err));
          })
        }
    }, 5000)
   },[props.org]);
  

  if (props.isUserAuthenticated){
   return (
    <Nav justify="between" direction="row" pad="xsmall"  overflow="auto" background="navBar" style={{ zIndex: '1' }} >
        <Box direction="row" justify='between'>
          <Button
            icon={<MenuIcon />}
            onClick={(e) => props.toggleSidebar(e)}
            focusIndicator={false}
            hoverIndicator
          />
          
          <Heading size="small" level="3" margin="small">
            LabShip
          </Heading>
          
          </Box>
          <Box direction='row'>
             {(logoLoad ? <Spinner /> : <img alt="Company Logo" src={logoUrl} width='120px' height='50px'  /> )}
           </Box>
      </Nav>
     )
    } else { 
    return (
      <Nav align="center" justify="between" direction="row" pad="xsmall" gap="xsmall" overflow="auto" background="navBar" elevation='medium' style={{ zIndex: '1' }}>
        <Box align="center" justify="center" direction="row">
          <Heading size="small" level="3" margin="medium">
            LabShip
          </Heading>
        </Box>
      </Nav>
    )
  }
}

export default withRouter(NavigationBar)
